import {
  FlattenedMapCommunityDetail,
  MapLocation,
  MapLocationOptions
} from '@src/types/map';

export const getFilteredMapData = (
  mapData: FlattenedMapCommunityDetail[],
  selectedLocation: MapLocation
) => {
  let filteredData: Array<FlattenedMapCommunityDetail> = mapData;

  if (selectedLocation?.state !== 'all') {
    filteredData = mapData?.filter(
      (item) => item.state?.slug === selectedLocation?.state
    );
  }

  if (selectedLocation?.region !== 'all') {
    filteredData = filteredData?.filter(
      (item) => item.region?.slug === selectedLocation?.region
    );
  }

  if (selectedLocation?.area !== 'all') {
    filteredData = filteredData?.filter(
      (item) => item.area?.slug === selectedLocation?.area
    );
  }

  if (selectedLocation?.suburb !== 'all') {
    filteredData = filteredData?.filter(
      (item) => item.suburb?.slug === selectedLocation?.suburb
    );
  }

  return filteredData;
};

export const getLocationName = (
  newSelectedLocation: MapLocation,
  communityLocations: MapLocationOptions
) => {
  const { state, region, area, suburb } = newSelectedLocation;
  const stateData = state && communityLocations.states?.[state];
  if (!stateData) {
    return '';
  }
  if (suburb !== 'all' && region && area && suburb) {
    return stateData.regions[region]?.areas[area]?.suburbs[suburb]?.label || '';
  }
  if (area !== 'all' && region && area) {
    return stateData.regions[region]?.areas[area]?.label || '';
  }
  if (region !== 'all' && region) {
    return stateData.regions[region]?.label || '';
  }
  return stateData.label || '';
};
